module.exports = __webpack_public_path__ + "static/mask2-05318413014fc3e4ac6b219d5cd24392.png";